import { Component, Input, OnInit, TemplateRef, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { modalConfigurationSmall } from 'src/app/_configs';
import { SchoolUserTypeDetail, SystemUserType } from 'src/app/_models';
import { ChangePassword } from 'src/app/_models/users/change-password';
import { PasswordValidation } from 'src/app/_validators/passwords-validator';
import { environment } from 'src/environments/environment';

import { LanguageService } from '../../_services';
import { BaseComponent } from './../../_base/base.component';
import { CurrentUserLoggedIn } from './../../_models/users/current-user-logged-in';
import { UserService } from './../../_services/users/user.service';

declare var $;
@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserMenuComponent extends BaseComponent implements OnInit {
  @Input()
  userProfileRoute: string = null;
  @Input()
  isSmallImage: boolean = false;
  public userImage = '../assets/Images/users/user.jpg';
  modalRef: BsModalRef;
  types: any;
  userType: string = 'Manager';
  //
  changePassword: ChangePassword = new ChangePassword();
  passwordForm: FormGroup;
  oldPassword: AbstractControl;
  newPassword: AbstractControl;
  confirmPassword: AbstractControl;
  passwords: FormGroup;
  currentLoggedInUser: CurrentUserLoggedIn = new CurrentUserLoggedIn();
  defaultImgUrl: string = '../../assets/Images/users/default-user.jpg';
  environment = environment;
  userSchoolsTypes: SchoolUserTypeDetail[] = [];
  @Input('currentUserType') currentUserType: SystemUserType[] = [];
  @Input('selectedUserTypeId') selectedUserTypeId: number;
  constructor(
    public lang: LanguageService,
    private _userService: UserService,
    private modalService: BsModalService,
    private _fb: FormBuilder,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.closeMenu();
    this.types = ['Manager', 'Parent'];
    this.getCurrentLoggedInUser();
    this.initChangePasswordForm();
  }

  setLang(): void {
    if (this.translateService.currentLang === 'en') {
      this.translateService.use('ar');
      localStorage.setItem('lang', 'ar');
      this.settings.rtl = true;
    } else {
      this.translateService.use('en');
      localStorage.setItem('lang', 'en');
      this.settings.rtl = false;
    }
  }

  closeMenu() {
    if ($('.collapse_img + .collapse.show').length > 0) {
      $('.collapse_img').click();
    }
  }

  getCurrentLoggedInUser() {
    const user = localStorage.getItem('currentUser');
    if (user) {
      this.currentLoggedInUser = JSON.parse(user); // convert to object

      this.changePassword.userId = this.currentLoggedInUser.id;
      const userTypesSchools = localStorage.getItem('schools');
      if (userTypesSchools) {
        this.userSchoolsTypes = JSON.parse(userTypesSchools);
      }
    }
  }

  logOut() {
    this._userService.logOut().subscribe(
      () => {
        this._userService.logoutReset();
      },
      () => {
        this._userService.logoutReset();
      }
    );
  }
  openModal(templateRef: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(templateRef, modalConfigurationSmall);
  }

  modalClose(): void {
    this.changePassword = new ChangePassword();
    this.modalRef.hide();
  }

  initChangePasswordForm() {
    this.passwordForm = this._fb.group({
      oldPassword: ['', Validators.compose([Validators.required])],
      passwords: this._fb.group(
        {
          newPassword: ['', Validators.compose([Validators.required])],
          confirmPassword: ['', Validators.compose([Validators.required])]
        },
        {
          validator: PasswordValidation.MatchPassword
        }
      )
    });
    this.passwords = <FormGroup>this.passwordForm.controls['passwords'];
    this.newPassword = this.passwords.controls['newPassword'];
    this.confirmPassword = this.passwords.controls['confirmPassword'];
    this.oldPassword = this.passwordForm.controls['oldPassword'];
  }
  // change password
  submitChangePassword() {
    if (this.passwordForm.valid) {
      this._userService.changePassword(this.changePassword).subscribe(data => {
        this.showSuccess('modalMessges.Common.DataHasBeenSaved');
        this.changePassword = new ChangePassword();
        this.modalRef.hide();
      });
    }
  }
  // handel set roles based on user type selected
  userTypeChange() {
    this._userService.setRoles([]);
    BaseComponent.spinner.isActive = true;
    this._userService.getListRolesNameByUserTypeId(this.selectedUserTypeId).subscribe(
      (data: string[]) => {
        this._userService.setRoles(data);
        BaseComponent.spinner.isActive = false;
      },
      error => {
        this.showError(error);
        BaseComponent.spinner.isActive = false;
      }
    );
  }

  LockScreen() {
    const temp = JSON.parse(localStorage.getItem('currentUser'));
    temp.isLook = true;
    localStorage.setItem('currentUser', JSON.stringify(temp));
    this.GoTo('Login/LookScreen');
  }

  GoTo(url: string): void {
    this.router.navigate([url]);
  }
}
